import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { JobItemComponent } from './job-item/job-item.component';
import { JobFilterComponent } from './job-filter/job-filter.component';
import { JobFilterFormDataSchema } from '@app/schemas/job-filter';
import { LoaderOverlayComponent } from '@app/shared/loader-overlay/loader-overlay.component';
import { Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import { CareerGoalDialogComponent } from '@app/shared/results/career-goal-dialog/career-goal-dialog.component';
import { JobUserContextSchema } from '@app/schemas/jobs';
import { RouterLink } from '@angular/router';
import { analytics } from '@app/events/segment/analytics';

@Component({
  selector: 'app-job-list-module',
  imports: [
    JobItemComponent, 
    JobFilterComponent,
    LoaderOverlayComponent,
    RouterLink,
  ],
  templateUrl: './job-list-module.component.html',
  styleUrl: './job-list-module.component.css'
})
export class JobListModuleComponent implements OnInit {
  @Output() jobClickEmitter = new EventEmitter<string>();
  @Output() filterFormEmitter = new EventEmitter<JobFilterFormDataSchema>();
  @Output() sortEmitter = new EventEmitter<string>();

  isCareerGoalSet: boolean = true;

  isSortedList: boolean = false;
  public showLoaderOverlay: boolean = false;
  public userJobFilters!: JobFilterFormDataSchema;
  public userContext!: JobUserContextSchema | {};
  public userCareerName: string = '';
  public userCareerOnetCode: string = '';
  public isFilterTabOpen: boolean = false;

  readonly itemDialog = inject(MatDialog);
  readonly careerGoalDialogWidth = '650px';

  constructor(
    private store: Store<{ 
      globalLoader: boolean, 
      careerGoal: string,
      jobFilter: JobFilterFormDataSchema, 
      jobUserContext: JobUserContextSchema | {},
    }>
  ) {
    this.store.select('globalLoader').subscribe((value) => {
      this.showLoaderOverlay = value;
    });
    this.store.select('careerGoal').subscribe((value) => {
      this.isCareerGoalSet = value ? true : false;
      this.userCareerOnetCode = value;
    });
    this.store.select('jobFilter').subscribe(value => this.userJobFilters = value);
    this.store.select('jobUserContext').subscribe(value => this.userContext = value);
  }

  ngOnInit() {
    this.userCareerName = (this.userContext as JobUserContextSchema)?.careerGoal?.careerName || '';
  }

  filterJobList(event: JobFilterFormDataSchema) {
    this.filterFormEmitter.emit(event);
  }

  sortJobList(type: string) {
    this.sortEmitter.emit(type);
  }

  onClickJobItem(jobId: string) {
    this.jobClickEmitter.emit(jobId);
  }

  navigateToCareerGoal() {
    const ref = this.itemDialog.open(CareerGoalDialogComponent, {
      minWidth: this.careerGoalDialogWidth,
      maxWidth: this.careerGoalDialogWidth,
      width: this.careerGoalDialogWidth,
    });

    ref.componentInstance.showCloseIcon = true;

    analytics.track('Job List Goal', {
      section: 'job',
      current_goal: this.userCareerName || null
    });
  }

  onFilterTabToggle(isOpen: boolean) {
    this.isFilterTabOpen = isOpen;
  }
}
